
import { motion } from 'framer-motion';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black py-16 px-6 border-t border-gray-800">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">SuperOne Business Suite</h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Die komplette Online-Plattform für erfolgreiche SuperOne-Partner
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:bg-[#0066FF] hover:text-white transition-all cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:bg-[#0066FF] hover:text-white transition-all cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:bg-[#0066FF] hover:text-white transition-all cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-bold mb-4">Produkt</h4>
            <ul className="space-y-3">
              <li>
                <a href="#funktionen" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Funktionen
                </a>
              </li>
              <li>
                <a href="#funktionsweise" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Funktionsweise
                </a>
              </li>
              <li>
                <a href="/registrieren" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Kostenlos starten
                </a>
              </li>
              <li>
                <a href="/login" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Login
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-bold mb-4">Support</h4>
            <ul className="space-y-3">
              <li>
                <a href="/kontakt" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Kontakt
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Hilfe-Center
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Dokumentation
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Status
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-bold mb-4">Rechtliches</h4>
            <ul className="space-y-3">
              <li>
                <a href="/impressum" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Impressum
                </a>
              </li>
              <li>
                <a href="/datenschutz" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Datenschutz
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  AGB
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer">
                  Cookie-Richtlinie
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2024 SuperOne Business Suite. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-2">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#0066FF] text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
